<template>
  <el-card>
    <el-form inline>
      <el-form-item label="关键词">
        <el-input v-model="query.keyword" placeholder="昵称/openid" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadData">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" border>
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column label="头像" width="80">
        <template slot-scope="scope">
          <el-avatar :src="scope.row.avatar" :size="50">
            <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" />
          </el-avatar>
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="昵称" />
      <el-table-column prop="totalSubmitCount" label="提交次数" width="100" />
      <el-table-column prop="approvedSubmitCount" label="有效次数" width="100" />
      <el-table-column prop="hasProfileAuth" label="资料授权" width="120">
        <template slot-scope="scope">{{ scope.row.hasProfileAuth ? '已授权' : '未授权' }}</template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="180" />
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button size="mini" @click="disableUser(scope.row)">禁用</el-button>
          <el-button size="mini" type="success" @click="enableUser(scope.row)">启用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handlePageChange"
      :current-page="query.page"
      :page-size="query.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      style="margin-top: 20px; text-align: right;"
    />
  </el-card>
</template>

<script>
import { getUserPage, updateUserStatus } from '@/api'

export default {
  data () {
    return {
      query: { page: 1, pageSize: 10, keyword: '' },
      rows: [],
      total: 0
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      const res = await getUserPage(this.query)
      this.rows = (res.data && res.data.rows) || []
      this.total = (res.data && res.data.total) || 0
    },
    handlePageChange (page) {
      this.query.page = page
      this.loadData()
    },
    async disableUser (row) {
      await updateUserStatus(row.id, { status: 0 })
      this.$message.success('已禁用')
      this.loadData()
    },
    async enableUser (row) {
      await updateUserStatus(row.id, { status: 1 })
      this.$message.success('已启用')
      this.loadData()
    }
  }
}
</script>
